/* ==========================================================================
   LIGHTINDERM — voile et blocage de navigation pour la bannière Cookiebot

   La config « Pop up » ne fournit aucun voile natif (vérifié sur le site :
   #CybotCookiebotDialogBodyUnderlay est absent). Ce script se contente de :
     1. créer le voile derrière le dialogue ;
     2. verrouiller le scroll de la page tant que la bannière est là ;
     3. empêcher Échap de fermer sans réponse.

   Il ne décide jamais de l'affichage : c'est Cookiebot qui l'ouvre et le
   ferme. Si ce fichier ne se charge pas, la bannière reste utilisable, sans
   voile ni verrou.

   À charger dans le thème, en defer, après le script Cookiebot :
   <script src="lightinderm-cookiebot.js" defer></script>
   ========================================================================== */
(function () {
  "use strict";

  var SCRIM_ID = "lid-cookie-scrim";
  var DIALOG_ID = "CybotCookiebotDialog";
  var locked = false;
  var scrollY = 0;
  var raf = null;

  function dialog() {
    return document.getElementById(DIALOG_ID);
  }

  function isVisible(el) {
    if (!el) {
      return false;
    }
    var s = window.getComputedStyle(el);
    return s.display !== "none" && s.visibility !== "hidden" && el.offsetHeight > 0;
  }

  function addScrim() {
    if (document.getElementById(SCRIM_ID)) {
      return;
    }
    var el = document.createElement("div");
    el.id = SCRIM_ID;
    el.setAttribute("aria-hidden", "true");
    document.body.appendChild(el);
  }

  function removeScrim() {
    var el = document.getElementById(SCRIM_ID);
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  function lock() {
    if (locked) {
      return;
    }
    locked = true;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    /* Styles inline : ils devancent la feuille du thème sans !important. */
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = -scrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    addScrim();
  }

  function unlock() {
    if (!locked) {
      return;
    }
    locked = false;
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    /* Un scroll-behavior smooth sur le thème animerait ce retour. */
    var previous = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "auto";
    window.scrollTo(0, scrollY);
    document.documentElement.style.scrollBehavior = previous;
    removeScrim();
  }

  /* Pas de réponse implicite : Échap ne ferme pas la bannière. */
  function onKeydown(e) {
    if (!locked) {
      return;
    }
    if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  /* On suit l'état réel du dialogue plutôt que de se fier aux seuls
     événements : selon les versions, CookiebotOnDialogDisplay n'est pas
     toujours émis, et la bannière peut être réaffichée par Cookiebot.renew(). */
  function sync() {
    if (raf) {
      return;
    }
    raf = window.requestAnimationFrame(function () {
      raf = null;
      if (isVisible(dialog())) {
        lock();
      } else {
        unlock();
      }
    });
  }

  function boot() {
    if (!document.body) {
      window.setTimeout(boot, 30);
      return;
    }

    ["CookiebotOnDialogDisplay", "CookiebotOnDialogInit", "CookiebotOnLoad"].forEach(function (evt) {
      window.addEventListener(evt, sync);
    });
    ["CookiebotOnAccept", "CookiebotOnDecline"].forEach(function (evt) {
      window.addEventListener(evt, function () {
        window.setTimeout(sync, 0);
      });
    });

    document.addEventListener("keydown", onKeydown, true);

    /* Cookiebot injecte et masque le dialogue quand il veut : on observe. */
    new MutationObserver(sync).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"]
    });

    sync();
  }

  boot();
}());